export default { version: '7.8.0' };
